import { Box, FormControlLabel, Switch } from "@mui/material";
import { type FC, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useFlags } from "../../../../../server/optimizely";
import type { PollWrapperSchema } from "./types";

export const PollResultsToggle: FC = () => {
  const { t } = useTranslation();
  const { control, setValue, getValues } = useFormContext<PollWrapperSchema>();
  const {
    flags: { enable_show_poll_results },
  } = useFlags("enable_show_poll_results");

  useWatch({ control, name: "poll.show_poll_results" });
  const show_poll_results = getValues("poll.show_poll_results");

  const handleToggle = useCallback(
    (checked: boolean) => {
      setValue("poll.show_poll_results", checked);
    },
    [setValue],
  );

  if (!enable_show_poll_results) return null;

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch checked={show_poll_results} onChange={(e) => handleToggle(e.target.checked)} />
        }
        label={t("Allow respondents to see all results after voting")}
      />
    </Box>
  );
};
